import {SelectFormWrap, SelectCustom, OptionCustom} from 'src/styles/common/CommonForm/selectform'
import React from 'react'
import {useRecoilState} from 'recoil'
import {InquiryTypeState} from 'src/store/recoil/common'

const SelectForm = (props: any) => {
    const {title} = props
    const [inquiryType, setInquiryType] = useRecoilState(InquiryTypeState)
    const selectOption = [
        {idx: 0, value: 'none', text: '문의유형을 선택해주세요'},
        {idx: 1, value: '서비스가입', text: '서비스가입'},
        {idx: 2, value: '서비스해지', text: '서비스해지'},
        {idx: 3, value: '이용문의', text: '이용문의'},
        {idx: 4, value: '제휴문의', text: '제휴문의'},
        {idx: 5, value: '기타', text: '기타'}
    ]
    return (
        <SelectFormWrap>
            <p>{title}</p>
            <SelectCustom
                defaultValue='none'
                onChange={(e) => {
                    setInquiryType(e.target.value)
                }}
                color={`${inquiryType !== 'none' && 'active'}`}
            >
                {selectOption.map((element: any) => (
                    <React.Fragment key={element.idx}>
                        {element.value === 'none'
                            ? (
                                <OptionCustom disabled hidden value='none'>
                                    {element.text}
                                </OptionCustom>
                            )
                            : (
                                <OptionCustom value={element.value}>{element.text}</OptionCustom>
                            )}
                    </React.Fragment>
                ))}
            </SelectCustom>
        </SelectFormWrap>
    )
}
export default SelectForm
